export default "__VITE_ASSET__CO4YhYW$__"